import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './promotion.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Promotion = _ref => {
  var backgroundColour = _ref.backgroundColour,
    headingColour = _ref.headingColour,
    headingCopy = _ref.headingCopy,
    bodyCopyColour = _ref.bodyCopyColour,
    bodyCopy = _ref.bodyCopy,
    buttonColour = _ref.buttonColour,
    destinationURL = _ref.destinationURL,
    buttonCopy = _ref.buttonCopy,
    disclaimerColour = _ref.disclaimerColour,
    disclaimerCopy = _ref.disclaimerCopy,
    logo = _ref.logo;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("div", {
    css: styles.container(backgroundColour)
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.header(headingColour)
  }, headingCopy), ___EmotionJSX("div", {
    css: styles.body(bodyCopyColour)
  }, bodyCopy)), ___EmotionJSX("div", {
    css: styles.buttonContainer
  }, ___EmotionJSX("a", {
    css: styles.button(buttonColour),
    href: destinationURL,
    target: "_blank",
    rel: "noreferrer",
    onClick: () => sendEvent('sponsorship-clicked')
  }, buttonCopy)), ___EmotionJSX("div", {
    css: styles.flexContainer
  }, ___EmotionJSX("div", {
    css: styles.disclaimerCopy(disclaimerColour)
  }, disclaimerCopy), ___EmotionJSX("div", {
    css: styles.logo
  }, ___EmotionJSX("img", {
    src: logo.imageURL,
    width: logo.width,
    height: logo.height,
    alt: ""
  }))));
};
Promotion.propTypes = {
  headingCopy: PropTypes.string,
  headingColour: PropTypes.string,
  bodyCopy: PropTypes.string,
  bodyCopyColour: PropTypes.string,
  buttonCopy: PropTypes.string,
  buttonColour: PropTypes.string,
  disclaimerCopy: PropTypes.string,
  disclaimerColour: PropTypes.string,
  destinationURL: PropTypes.string,
  backgroundColour: PropTypes.string,
  logo: PropTypes.shape({
    imageURL: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  })
};
Promotion.defaultProps = {
  headingCopy: '',
  headingColour: '',
  bodyCopy: '',
  bodyCopyColour: '',
  buttonCopy: '',
  buttonColour: '',
  disclaimerCopy: '',
  disclaimerColour: '',
  destinationURL: '',
  backgroundColour: '',
  logo: PropTypes.shape({
    imageURL: '',
    width: undefined,
    height: undefined
  })
};
export default Promotion;